import React, { useState } from "react";
import { authAPI } from "API/auth";
import {
  AnimatedLink,
  ErrorNotification,
  Spinner,
} from "components/styles/smallComponents";
import {
  Bottom,
  Form,
  Input,
  InputControl,
  Label,
  Submit,
  SuccessRegister,
  changeForgottenPwdInputs,
  Header,
} from "./data";
import { Navigate, useParams } from "react-router-dom";
import { FRONTEND_ENDPOINTS } from "Theconstants";
import { HASH_LINKS } from "Theconstants";
import { useAppDispatch, useAppSelector } from "context/store";

export const ChangeForgottenPwd = () => {
  const { error, loading } = useAppSelector((state) => state.user);
  const { secretToken } = useParams();
  const dispatch = useAppDispatch();
  const [input, setInput] = useState<ChangeForgottenPwdForm>({
    contraseña: "",
    confirmaContraseña: "",
  });
  //useEffect al ppio si quiero rebotar a alguien?
  const [success, setSuccess] = useState<boolean | string>(false);

  if (typeof secretToken !== "string")
    return <Navigate to={`${FRONTEND_ENDPOINTS.LOGIN}#`} />;

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setSuccess(false);
    authAPI.changeForgottenPwd(
      dispatch,
      input,
      secretToken as string,
      setSuccess
    );
  }
  return (
    <>
      <Form onSubmit={handleSubmit}>
        <Header>Generá tu nueva contraseña.</Header>
        <ErrorNotification show={error}>{error}</ErrorNotification>
        {success && <SuccessRegister>{success}</SuccessRegister>}
        {changeForgottenPwdInputs?.map((i) => {
          const { type, id, label } = i;

          return (
            <InputControl key={id}>
              <Label htmlFor={id}>{label}</Label>
              <Input
                as="input"
                type={type}
                id={id}
                placeholder={label}
                name={id}
                value={input[id]}
                onChange={(e) =>
                  setInput({ ...input, [e.target.name]: e.target.value })
                }
              ></Input>
            </InputControl>
          );
        })}
        <Submit disabled={loading}>
          {loading ? <Spinner /> : "Cambiar contraseña"}
        </Submit>
        <Bottom>Elegí tu nueva contraseña.</Bottom>
        <Bottom>
          <AnimatedLink to={`${FRONTEND_ENDPOINTS.LOGIN}#${HASH_LINKS.TOP}`}>
            Volver a inicio de sesión.
          </AnimatedLink>
        </Bottom>
      </Form>
    </>
  );
};
